import { render, staticRenderFns } from "./AppSideNavTemplate.vue?vue&type=template&id=17b2317d&"
import script from "./AppSideNavTemplate.vue?vue&type=script&lang=js&"
export * from "./AppSideNavTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AppSideNavTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppSideNavTemplate.vue"
export default component.exports